import easyFirestore from "./easyFirestore"

const plugins = [easyFirestore];

export default plugins;
